import { render, staticRenderFns } from "./UpdateRecipeCost.vue?vue&type=template&id=234164f0&scoped=true"
import script from "./UpdateRecipeCost.vue?vue&type=script&lang=ts"
export * from "./UpdateRecipeCost.vue?vue&type=script&lang=ts"
import style0 from "./UpdateRecipeCost.vue?vue&type=style&index=0&id=234164f0&prod&scoped=true&lang=css"
import style1 from "./UpdateRecipeCost.vue?vue&type=style&index=1&id=234164f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234164f0",
  null
  
)

export default component.exports